
export default function WhatWeDo() {
  const services = [
    {
      icon: 'ri-window-line',
      title: 'Website Builds',
      description: 'Custom, professional websites designed to convert visitors into customers'
    },
    {
      icon: 'ri-robot-2-line',
      title: 'AI Automation Solutions',
      description: 'Streamline your business operations with intelligent automation tools'
    },
    {
      icon: 'ri-funnel-line',
      title: 'Lead Capture Funnels',
      description: 'Optimized funnels that turn traffic into qualified leads for your business'
    },
    {
      icon: 'ri-search-eye-line',
      title: 'Business Visibility Optimization',
      description: 'Get found online by customers actively searching for your services'
    }
  ];

  return (
    <section id="services" className="relative py-32 bg-black overflow-hidden">
      <div className="absolute inset-0 bg-gradient-radial from-[#0a1628]/30 via-transparent to-transparent"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <h2 className="text-5xl lg:text-6xl font-bold text-white mb-4">What We Do</h2>
          <div className="w-16 h-1 bg-[#1e3a8a] mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-[#050a14] border border-[#1e3a8a]/20 rounded-3xl p-10 hover:border-[#1e3a8a]/50 transition-all duration-300 hover:shadow-2xl hover:shadow-[#1e3a8a]/10 hover:-translate-y-2 cursor-pointer"
            >
              <div className="w-20 h-20 bg-[#0a1628] border border-[#1e3a8a]/30 rounded-full flex items-center justify-center mb-6 group-hover:border-[#1e3a8a]/50 transition-colors">
                <i className={`${service.icon} text-4xl text-white/70`}></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4 text-center">{service.title}</h3>
              <p className="text-white/70 text-center leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
